import { GenericCollectionFactory } from "../_generics";
import { GENERIC_IDS } from "../_constants/generics.constants";

export const AuditLogsCollection = GenericCollectionFactory(GENERIC_IDS.AUDIT, "id");